import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cotisations',
  templateUrl: './cotisations.component.html',
  styleUrls: ['./cotisations.component.scss']
})
export class CotisationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
